<script lang="ts">
    import * as Dialog from "$lib/components/ui/dialog";
    import { Button } from "$lib/components/ui/button";
    import { t  } from 'svelte-i18n'
    import { Pencil } from 'lucide-svelte';
    import { Input } from "$lib/components/ui/input";
    import { Label } from "$lib/components/ui/label";
    import { useUpdateDocument } from "../hooks/useUpdateDocument";
    import { validator } from '@felte/validator-zod';
    import * as zod from 'zod';
    import { createForm } from 'felte';
    import type { DocumentMeta } from "$src/domain/projects/documents/DocumentMeta";
    import type { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";

    export let groupStoreId: number
	export let projectId: number
    export let document: DocumentSummary

    const mutation = useUpdateDocument();

    const schema = zod.object({
        title: zod.string()
            .min(1, $t('page.projects.documents.name-required'))
            .max(50, $t('page.projects.documents.name-max-length')),
        folderName: zod.string().max(150, $t('page.projects.documents.foldername-max-length')),
    });

    type FormValues = zod.infer<typeof schema>;
        
    $: editForm = createForm({
        initialValues: {
            title: document.title,
            folderName: document.folderName
        },
        onSubmit: handleSubmit,      
        extend: validator({ schema }),
    });
    
    $: form = editForm.form;
    $: data = editForm.data;
    $: errors = editForm.errors;

    function handleSubmit(values: FormValues) {

        var meta: DocumentMeta = {
            title: values.title,
            folderName: values.folderName
        };
        
        $mutation.mutate({groupStoreId, projectId, documentId: document.id, meta});

        dialogOpen = false;
    }

    let dialogOpen = false;
</script>

<Dialog.Root bind:open={dialogOpen} >
    <Dialog.Trigger>
        <Button size="sm" variant="outline">
            <Pencil class="h-3.5 w-3.5" />
        </Button>
    </Dialog.Trigger>
    <Dialog.Content class="max-w-md">
        <Dialog.Header>
            <Dialog.Title>
                {$t('page.projects.documents.edit')}
            </Dialog.Title>
        </Dialog.Header>
        <form use:form>
           
            <div class="grid gap-4 py-4">
                <div class="grid grid-cols-4 items-center gap-4">
                    <Label for="title" class="text-right">
                        {$t('page.projects.documents.title')}
                    </Label>
                    <Input name="title"  bind:value={$data.title} class="col-span-3" />
                    {#if $errors.title}
                        <div class="col-span-4 text-right text-sm" >{$errors.title}</div>
                    {/if}
                </div>
                <div class="grid grid-cols-4 items-center gap-4">
                    <Label for="folderName" class="text-right">
                        {$t('page.projects.documents.folder')}
                    </Label>
                    <Input name="folderName" bind:value="{$data.folderName}" class="col-span-3" />
                    {#if $errors.folderName}
                        <div class="col-span-4 text-right text-sm" >{$errors.folderName}</div>
                    {/if}
                </div>
            </div>
            <Dialog.Footer class="flex flex-row w-full justify-between">
                <Button type="submit">
                    {$t('global.messages.edit')}
                </Button>
                <Button variant="secondary" class="flex justify-start"  on:click={() => {dialogOpen = false;}}> 
                    {$t('global.messages.cancel')}
                </Button>
            </Dialog.Footer>
        </form>
    </Dialog.Content>
  </Dialog.Root>